import type { OnboardingStepView } from '@/viewmodel/features/onboarding/types';

export function toOnboardingSteps(labels: string[], stepIndex: number): OnboardingStepView[] {
  return labels.map((label, i) => ({
    label,
    completed: i < stepIndex,
    active: i === stepIndex,
  }));
}

export function completionPercent(steps: OnboardingStepView[]): number {
  if (steps.length === 0) return 0;
  return Math.round((steps.filter((s) => s.completed).length / steps.length) * 100);
}
